import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Box, Divider, Menu, MenuItem, Stack, Tooltip, Typography } from "@mui/material";
import { useApolloClient } from "@apollo/client";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {jwtDecode} from 'jwt-decode';
import Cookies from "js-cookie";


// Helper to decrypt the token
const decodeToken = (token: string) => {
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken;
  } catch (error) {
    console.error('Invalid token:', error);
    return null;
  }
};


const UserProfile: React.FC = () => {
  const [userName, setUserName] = useState<string>("");
  const [companyName, setCompanyName] = useState<string>("");

  useEffect(() => {
    // Get the token from localStorage
    const encryptedToken = Cookies.get("authToken");
    if (encryptedToken) {
      // Decrypt the token to get user data
      const userData = decodeToken(encryptedToken) as {userName: string, userId: string, companyId: string, companyName: string};
      setUserName(userData?.userName || "")
      setCompanyName(userData?.companyName || "")
    }
  }, []);
  

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const client = useApolloClient();

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Remove cookie with same attributes it was set with
    Cookies.remove("authToken", {
      secure: true,
      sameSite: "None",
    });
    client.clearStore();
    navigate("/login");
  };

  return (
    <div>
      <Stack
        direction={"row"}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer", // Add pointer cursor for the box
          padding: 1, // Optional: Add some padding for better clickability
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.1)", // Optional: Add hover effect
          },
        }}
        onClick={handleMenu}
      >
        <AccountCircle sx={{ color: "black" }} />
        {userName && (
          <MenuItem
            disableRipple // Removes hover effect
            sx={{
              pointerEvents: "none", // Prevents pointer interactions
            }}
          >
            <Stack direction={"column"}>
              <Typography variant="overline" color="textSecondary" fontWeight={"bold"}>
                { companyName }
              </Typography>
              <Typography variant="body2" color="textSecondary">
                { userName }
              </Typography>
            </Stack>
          </MenuItem>
        )}
      </Stack>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom", // Position the menu below the anchor element
          horizontal: "right", // Align the right edges of the menu and the anchor element
        }}
        keepMounted
        transformOrigin={{
          vertical: "top", // Ensure the menu transforms from the top of its bounding box
          horizontal: "right", // Align the menu's right edge with the anchor
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {!userName && (
          <Stack>
            <MenuItem component={Link} to="/login">
              Login
            </MenuItem>
            <MenuItem component={Link} to="/signup">
              Sign Up
            </MenuItem>
          </Stack>
        )}
        {userName && (
          <Stack>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
            <Divider />
            <MenuItem component={Link} to="/my-biz/my-listings">
              My Listings
            </MenuItem>
            <MenuItem component={Link} to="/my-biz/orders">
              My Orders
            </MenuItem>
            <MenuItem component={Link} to="/my-biz/my-connections">
              My Connections
            </MenuItem>
            <Tooltip title="Coming soon" arrow>
              <Box sx={{ display: "flex", alignItems: "center", cursor: "not-allowed" }}>
                <MenuItem disabled>
                  Purchases
                </MenuItem>
              </Box>
            </Tooltip>
            <Tooltip title="Coming soon" arrow>
              <Box sx={{ display: "flex", alignItems: "center", cursor: "not-allowed" }}>
                <MenuItem disabled>
                  Inbox
                </MenuItem>
              </Box>
            </Tooltip>
            <Tooltip title="Coming soon" arrow>
              <Box sx={{ display: "flex", alignItems: "center", cursor: "not-allowed" }}>
                <MenuItem disabled>
                  Settings
                </MenuItem>
              </Box>
            </Tooltip>
          </Stack>
        )}
      </Menu>
    </div>
  );
};

export default UserProfile;
